import { Modal, Button } from "@mui/material";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { useState } from "react";
import styles from './ButtonOpenModalDeleteComponent.module.css'


interface ModalDeleteProps {
    handleDeleteComponent: (idComponent: number) => void
    id_component: number
}

export function ButtonOpenModalDeleteComponent({ handleDeleteComponent, id_component }: ModalDeleteProps) {
    const [openDeleteModal, setOpenDeleteModal] = useState(false)

    function handleOpemModal() {
        setOpenDeleteModal(true)
    }

    function handleCloseModal() {
        setOpenDeleteModal(false)
    }

    function handleDelete() {
        handleDeleteComponent(id_component)
        handleCloseModal()
    }

    return (
        <>
            <Modal
                onClose={handleCloseModal}
                open={openDeleteModal}
                className={styles.modal_delete_component}
            >
                <div className={styles.container_modal}>
                    <p>Deseja excluir este componenete?</p>

                    <div className={styles.options_button}>
                        <Button
                            variant='contained'
                            title='Excluir'
                            onClick={handleDelete}
                        >
                            Sim
                        </Button>
                        <Button
                            variant='contained'
                            onClick={handleCloseModal}
                        >
                            Não
                        </Button>
                    </div>

                </div>

            </Modal>

            <Button
                variant='contained'
                title='Excluir'
                onClick={handleOpemModal}
            >
                <DeleteOutlineRoundedIcon />
            </Button>
        </>
    )
}



